import { defineStore } from 'pinia'
import state from './common/state'
import actions from './common/actions'
import getters from './common/getters'

export const usePersonalStore = defineStore('personal', {
  state,
  actions,
  getters
})